'use strict';

var types = require('./types-169d4b99.js');

var getPLPImageSizeInfo = function (screenWidth) {
    var screenHeight = Math.round((screenWidth * 4) / 3);
    var horizontalPadding = Math.round(screenWidth / 12.5);
    var verticalPadding = Math.round(screenHeight / 5.681818182);
    return {
        padding: {
            top: verticalPadding,
            right: horizontalPadding,
            bottom: verticalPadding,
            left: horizontalPadding,
        },
        size: {
            width: screenWidth,
            height: screenHeight,
        },
    };
};
var getPLPHeroImageSizeInfo = function (screenWidth, imageTag) {
    var heightDivisor = imageTag === types.ProductImageTag.DETAIL ? 4 / 3 : 1.03380281690141;
    var paddingMultiplier = imageTag === types.ProductImageTag.DETAIL ? 0 : 1;
    var screenHeight = Math.round(screenWidth * heightDivisor);
    var horizontalPadding = Math.round(screenWidth / 12.5);
    var verticalPadding = Math.round(screenHeight / 7.3529411765);
    return {
        padding: {
            top: verticalPadding * paddingMultiplier,
            right: horizontalPadding * paddingMultiplier,
            bottom: Math.round(verticalPadding / 2) * paddingMultiplier,
            left: horizontalPadding * paddingMultiplier,
        },
        size: {
            width: screenWidth,
            height: screenHeight,
        },
    };
};

exports.getPLPHeroImageSizeInfo = getPLPHeroImageSizeInfo;
exports.getPLPImageSizeInfo = getPLPImageSizeInfo;
//# sourceMappingURL=imageSizeConfigs-192d99c9.js.map
